import { orderDrafts } from '@consumer/api'
import type { OrderTemplate } from '@consumer/services/order/types'
import type GiftFees from '@consumer/types/GiftFees'
import { isMobileDevice } from '@consumer/utils/device'

export type DeviceType = 'mobile' | 'desktop'

export async function purchaseOrder ({ order, fees, ...additionalData }: {
  order: OrderTemplate
  fees: GiftFees
  recaptchaToken?: string
}) {
  const data = {
    ...additionalData,

    // We want to verify that what the user sees is what they get.
    verifyTimestamp: order.updatedAt,
    fees,

    // Provided for verification purposes.
    phoneNumber: order.phoneNumber,

    // Payment Information
    cardholderName: order.billingName,
    stripeToken: order.stripeToken,
    ccLastFour: order.creditCard?.last4,
    savePaymentInformation: order.savePaymentInformation,
    paymentMethod: order.paymentMethod!,

    // Purchase Metadata
    browserLanguage: window.navigator.language,
    device: isMobileDevice() ? 'mobile' : 'desktop',
  }

  return orderDrafts.purchase({ params: order, data })
}
